import React from 'react';
import logo from '../../assets/logo.svg';
import { Button, Text } from '@creditinfo-ui/atoms';

const EleringConsent: React.FC = () => {
  const giveConsent = () => {
    window.location.href = process.env.REACT_APP_GRANT_CONSENT_URL ? process.env.REACT_APP_GRANT_CONSENT_URL : '#';
  };

  return (
    <div className="centered-box__container">
      <title>Electricity Meter Consent</title>
      <div className="centered-box__card">
        <div className="centered-box__card-inner">
          <img src={logo} alt="Creditinfo logo" className="centered-box__logo" />

          <Text size="extraTitle" variant="viewTitle">
            Electricity Meter Consent
          </Text>
          <Text>Authorize CreditInfo to access your electricity meter data via Elering.</Text>
          <div className="flex gap1">
            <Button onClick={giveConsent}>Grant consent</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EleringConsent;
